import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {MediaPageComponent} from './media-page/media-page.component';
import {ObjectViewModule} from '../object-view/object-view.module';
import {ObjectSearchModule} from '../object-search/object-search.module';
import {MediaCarouselModule} from '../media-carousel/media-carousel.module';
import {OperationsModule} from '../operations/operations.module';
import {OverviewFieldsModule} from '../overview-fields/overview-fields.module';
import {MatIconModule} from '@angular/material/icon';
import {ObjectContentTabModule} from '../object-content-tab/object-content-tab.module';
import {SharedModule} from '../shared/shared.module';



@NgModule({
  declarations: [
    MediaPageComponent
  ],
  imports: [
    CommonModule,
    ObjectViewModule,
    ObjectSearchModule,
    MediaCarouselModule,
    OperationsModule,
    OverviewFieldsModule,
    MatIconModule,
    ObjectContentTabModule,
    SharedModule
  ]
})
export class MediaPageModule { }
